import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "fixedtime-booking-modal-label"
}, "Fixed Time (will be seen on PI's tablet)", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-form-label" }, "Why are you fixing the time?", -1)
const _hoisted_10 = { class: "modal-footer" }

import $ from 'jquery';
import { ref, inject, computed } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'BookingFixedTimeModal',
  props: {
    id: {}
  },
  emits: ['hide'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const store = useStore();

const booking = computed(() => store.getters['diary/booking']);

const setBookingDeep = (payload: { path: string; data: any }): Promise<any> => {
 return store.dispatch('diary/setBookingDeep', payload);
};

const notes = ref(""); 
const emit = __emit
const props = __props;

const init = () => {
  notes.value = booking.value.fixedtimenotes;
};

const show = () => {
  if ($(`#${props.id}` + 'Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="' + props.id + 'Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#${props.id}`).show();
  }
}
const hide = () => {
  if ($(`#${props.id}`).length > 0) {
    $(`#${props.id}` + 'Backdrop').remove();
    $(`#${props.id}`).hide();
  }
};
const save = async () => {
  hide();
  setBookingDeep({ path: 'fixedtimenotes', data: notes.value });
};

__expose({init,show,hide});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.id,
    class: "modal",
    "data-keyboard": "true",
    tabindex: "-1",
    role: "dialog",
    "aria-labelledby": "`fixedtime-booking-modal-label`",
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "3",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((notes).value = $event))
            }, null, 512), [
              [_vModelText, notes.value]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Back "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-danger",
            "data-dismiss": "modal",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (save()), ["prevent"]))
          }, " Save ")
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})